import { useToggle } from "@uidotdev/usehooks";

import { Button } from "@/components/ui/button/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useCoupon } from "@/features/join/_api/use-coupon";
import { useCurrentPurchaseIntent } from "@/features/my/checkout/_api/use-current-purchase-intent";
import { AppliedPromoCode } from "@/features/my/checkout/_components/checkout-card/applied-promo-code";
import { InputPromoCode } from "@/features/my/checkout/_components/checkout-card/input-promo-code";

export const PromoCode = () => {
  const [showDiscountArea, toggleShowDiscountArea] = useToggle(false);

  const { data: purchaseIntent, isLoading: isLoadingPurchaseIntent } =
    useCurrentPurchaseIntent();

  const purchaseIntentPayload: any = purchaseIntent?.payload;

  const { data: discountDetail } = useCoupon(
    purchaseIntentPayload?.discountCode,
  );

  const isLoading = isLoadingPurchaseIntent;

  if (isLoading) {
    return <Skeleton className="h-10 w-full" />;
  }

  // An applied offer replaces the whole "Offer / Add code" affordance with a status
  // row: once a code is on the cart, "Offer" as a label with nothing beside it just
  // re-announced a money row that the ledger below already owns.
  if (discountDetail?.coupon?.valid) {
    return <AppliedPromoCode />;
  }

  return (
    <div className="px-4 space-y-1 py-3">
      <div className="flex justify-between items-center">
        <p className="text-sm">Offer</p>

        <Button
          onClick={() => toggleShowDiscountArea()}
          size="xs"
          className="px-0 no-underline"
          kind="link"
        >
          {showDiscountArea ? "Cancel" : "Add code"}
        </Button>
      </div>

      {showDiscountArea && <InputPromoCode />}
    </div>
  );
};
